import * as $ from 'jquery';
import * as _ from 'underscore';

import RoomType from '../models/RoomType';

export default class RoomTypeRepository {

    findAll(): JQueryPromise<RoomType[]> {
        return $.get( '/api/room-types' ).
            then( data => _.map(data, RoomType.bless) );
    }

}



/** WEBPACK FOOTER **
 ** ./src/repositories/RoomTypeRepository.ts
 **/